import styled from 'styled-components';

/**
 * The week and slot previews the course group form draws.
 *
 * These lived in CourseGroups.js while that page was the only place a course group could be
 * edited. The timetable can now create and edit one too, so they moved out alongside the form.
 * The Course Groups page still imports the few its read-only detail panel uses.
 */

// Styled components for week preview
export const WeekPreviewContainer = styled.div`
  margin-top: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  max-height: 200px;
  overflow-y: auto;
`;

export const WeekPreviewHeader = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 1fr 80px;
  background: #f3f4f6;
  padding: 8px 12px;
  font-weight: 600;
  font-size: 12px;
  color: #374151;
  position: sticky;
  top: 0;
`;

export const WeekPreviewRow = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 1fr 80px;
  padding: 6px 12px;
  font-size: 12px;
  color: ${props => props.$isHoliday ? '#9ca3af' : '#374151'};
  background: ${props => props.$isHoliday ? '#fef3c7' : (props.$isEven ? '#f9fafb' : 'white')};
  border-top: 1px solid #e5e7eb;

  &:first-of-type {
    border-top: none;
  }
`;

export const WeekPreviewBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  background: ${props => props.$isHoliday ? '#fbbf24' : '#10b981'};
  color: white;
`;

export const WeekPreviewSummary = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 8px;
  font-size: 13px;
  color: #6b7280;
`;

// Styled components for slot management (special term)
export const SlotPreviewContainer = styled.div`
  margin-top: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  max-height: 300px;
  overflow-y: auto;
`;

export const SlotPreviewHeader = styled.div`
  display: grid;
  grid-template-columns: 50px 120px 1fr 36px;
  background: #f3f4f6;
  padding: 8px 12px;
  font-weight: 600;
  font-size: 12px;
  color: #374151;
  position: sticky;
  top: 0;
  gap: 12px;
`;

export const SlotPreviewRow = styled.div`
  padding: 8px 12px;
  font-size: 12px;
  color: #374151;
  background: ${props => props.$isEven ? '#f9fafb' : 'white'};
  border-top: 1px solid #e5e7eb;

  &:first-of-type {
    border-top: none;
  }
`;

export const SlotRowMain = styled.div`
  display: grid;
  grid-template-columns: 50px 120px 1fr 36px;
  gap: 12px;
  align-items: center;
`;

export const SlotRowSub = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 6px;
  padding-left: 62px;
  font-size: 11px;
  color: #6b7280;
`;

export const SlotInputRow = styled.div`
  padding: 10px 12px;
  background: ${props => props.$isEven ? '#f9fafb' : 'white'};
  border-bottom: 1px solid #e5e7eb;
`;

export const SlotInputMain = styled.div`
  display: grid;
  grid-template-columns: 50px 120px 1fr 36px;
  gap: 12px;
  align-items: center;
`;

export const SlotInputSub = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 8px;
  padding-left: 62px;
`;

export const SlotPreviewSummary = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 8px;
  font-size: 13px;
  color: #6b7280;
`;

export const SlotBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  background: #8b5cf6;
  color: white;
  white-space: nowrap;
`;

// Styled components for slot multi-select
export const SlotSelectionBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: #f3f4f6;
  border-radius: 6px;
  margin-bottom: 8px;
`;

export const SlotCheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #8b5cf6;
  }
`;

export const SlotSelectionCount = styled.span`
  font-size: 12px;
  color: #6b7280;
  margin-left: auto;
`;

export const SlotRowCheckbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #8b5cf6;
`;
